import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { DialogContent as DialogContent$1 } from '@reach/dialog';
import { useTheme } from '../hooks/useTheme.js';

var DialogContent = forwardRef(function DialogContent(_a, ref) {
    var children = _a.children, size = _a.size, sx = _a.sx, _b = _a.themeKey, themeKey = _b === void 0 ? "dialogContent" : _b, props = __rest(_a, ["children", "size", "sx", "themeKey"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var dialogMarginXs = "16px";
    var dialogMargin = "24px";
    // width management technique to allow overlay is clickable from MUI dialog
    var baseStyle = {
        width: [
            "calc(100% - ".concat(dialogMarginXs, " * 2)"),
            "calc(100% - ".concat(dialogMargin, " * 2)"),
        ],
        m: [dialogMarginXs, dialogMargin],
    };
    var forwardProps = handleStyleProps({ size: size, sx: sx }, {
        themeKey: themeKey,
        baseStyle: baseStyle,
    });
    return (jsx(DialogContent$1, __assign({ ref: ref }, forwardProps, props, { children: children })));
});

export { DialogContent };
//# sourceMappingURL=DialogContent.js.map
